import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import img from "./app-download-teaser-image.jpg";
export function AppDownloadImage() {
  return React.createElement(BranchLink, {
    branchLink: RawBranchLink.AppTeaser,
    eventLabel: "app_page_download_image",
    title: ""
  }, React.createElement("img", {
    src: img,
    alt: "App Teaser Image"
  }));
}
export default AppDownloadImage;